module.exports = __webpack_public_path__ + "img/user-avatar-2.27855461.png";